<!--<ng-container *ngIf="this.view$ | async as view">-->
@for (button of this.actions; track button.name + button.actionName) {
  @if (button.mode == ActionMode.Navigate) {
    <a
      [routerLink]="button.route"
      [class]="button.buttonType | buttontypepipe"
      class="btn-sm btn"
      translate
      >
      {{ button.title }}
    </a>
  }
  @if (button.mode == ActionMode.Action) {
    <a
      [class]="button.buttonType | buttontypepipe"
      class="btn-sm btn"
      (click)="triggerAction(button.actionName)"
      translate
      >
      {{ button.title }}
    </a>
  }
}
<!--</ng-container>-->
